import React, { useState } from "react";
import "./App.css";
import Login from "./components/login";
import Signup from "./components/signup";

const App = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    name: "",
    confirm_Password: "",
  });
  const [errorMessage, setErrorMessage] = useState("");

  const toggleForm = () => {
    setIsLogin(!isLogin);
    setFormData({ email: "", password: "", name: "", confirm_Password: "" });
    setErrorMessage("");
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2>{isLogin ? "Login" : "Register"}</h2>

        {isLogin ? (
          <Login
            setErrorMessage={setErrorMessage}
            setFormData={setFormData}
            formData={formData}
          />
        ) : (
          <Signup
            setErrorMessage={setErrorMessage}
            setFormData={setFormData}
            formData={formData}
            toggleForm={toggleForm}
          />
        )}

        {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}

        <p className="toggle-text">
          {isLogin ? "Don't have an account?" : "Already have an account?"}
          <span onClick={toggleForm} className="toggle-link">
            {isLogin ? " Register" : " Login"}
          </span>
        </p>
      </div>
    </div>
  );
};

export default App;